import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import styles from './TextInputWrapper.module.css';
import { TextInputWrapperProps } from './types';
const TextInputWrapper = function TextInputWrapper(t0) {
  const $ = _c(29);
  const {
    label,
    name,
    description,
    error,
    warning,
    id,
    required,
    children,
    invisibleLabel,
    errorDisplay,
    className,
    hint,
    fullWidth
  } = t0;
  const t1 = fullWidth && fullWidth !== "mobile-only";
  const t2 = fullWidth && fullWidth === "mobile-only";
  let t3;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2) {
    t3 = classNames({
      "fullWidth": t1,
      "fullWidthOnMobile": t2
    }, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== hint || $[5] !== id || $[6] !== invisibleLabel || $[7] !== label || $[8] !== name || $[9] !== required) {
    t4 = label && <label htmlFor={id || name} className={classNames(styles.label, invisibleLabel && "sr-only")}>{label}{required && <span aria-hidden={true} className={styles.required}>*</span>}{hint ? <span className={classNames(styles.hint)} id={`${id}-hint`}>{hint}</span> : null}</label>;
    $[4] = hint;
    $[5] = id;
    $[6] = invisibleLabel;
    $[7] = label;
    $[8] = name;
    $[9] = required;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== description || $[12] !== name) {
    t5 = description && <p id={`${name}-description`} className={styles.description}>{description}</p>;
    $[11] = description;
    $[12] = name;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== error || $[15] !== errorDisplay || $[16] !== name) {
    t6 = error && errorDisplay === "all" && <p id={`${name}-error`} className={styles.error} aria-live="polite">{error}</p>;
    $[14] = error;
    $[15] = errorDisplay;
    $[16] = name;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== errorDisplay || $[19] !== name || $[20] !== warning) {
    t7 = warning && errorDisplay === "all" && <p id={`${name}-warning`} className={styles.warning} aria-live="polite">{warning}</p>;
    $[18] = errorDisplay;
    $[19] = name;
    $[20] = warning;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== children || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t8 = <div className={t3}>{t4}{t5}{children}{t6}{t7}</div>;
    $[22] = children;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};
export default TextInputWrapper;